<template>
  <Teleport to="body">
    <div
      ref="modal"
      class="modal status-dialog-modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content text-center">
          <div class="modal-body p-5">
            <PhCircleNotch
              v-if="type === 'loading'"
              :size="100"
              weight="bold"
              color="#0095e2"
              class="spin mb-4"
            />
            <PhCheck
              v-if="type === 'success'"
              :size="100"
              weight="bold"
              color="#3D8116"
              class="mb-4"
            />
            <PhX
              v-if="type === 'fail'"
              :size="100"
              weight="bold"
              color="#F24423"
              class="mb-4"
            />

            <h5 class="modal-title mb-3">
              {{ heading }}
            </h5>
            <div class="modal-description mb-4" v-html="description"></div>

            <default-button
              v-if="type === 'success'"
              :labelText="buttonLabel || 'Continue'"
              @click="handleContinue"
            />
            <default-button
              v-if="type === 'fail'"
              :labelText="'Try Again'"
              @click="handleCancel"
            />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { Modal } from "bootstrap"
import DefaultButton from "@/components/DefaultButton"
import { PhCircleNotch, PhCheck, PhX } from "@phosphor-icons/vue"

export default {
  name: "status-dialog",
  components: {
    DefaultButton,
    PhCircleNotch,
    PhCheck,
    PhX,
  },
  props: {
    heading: String,
    description: String,
    buttonLabel: String,
    type: { type: String, default: "loading" },
    show: { type: Boolean, default: false },
  },
  data: () => ({
    modalInstance: null,
  }),
  watch: {
    show: {
      immediate: true,
      handler(visible) {
        if (visible) {
          this.openModal()
        } else {
          this.closeModal()
        }
      },
    },
  },
  mounted() {
    this.modalInstance = Modal.getOrCreateInstance(this.$refs.modal, {
      backdrop: "static",
      keyboard: false,
    })

    if (this.show) {
      this.openModal()
    }
  },
  beforeUnmount() {
    this.destroyModal()
  },
  methods: {
    openModal() {
      if (this.modalInstance) {
        this.modalInstance.show()
      }
    },
    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide()
      }
    },
    destroyModal() {
      if (this.modalInstance) {
        this.modalInstance.dispose()
        this.modalInstance = null
      }
    },
    handleContinue() {
      this.$emit("continue")
    },
    handleCancel() {
      this.$emit("cancel")
    },
  },
}
</script>

<style scoped>
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.status-dialog-modal .modal-content {
  border-radius: 12px;
  border: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}

.status-dialog-modal .modal-title {
  color: var(--Gray-800, #3a4252);
  font-weight: 600;
}

.status-dialog-modal .modal-description {
  color: var(--Gray-800, #3a4252);
  font-weight: 400;
}
</style>
